import { Component } from '@angular/core';
import _toLower from 'lodash-es/toLower';
import _includes from 'lodash-es/includes';
import _toArray from 'lodash-es/toArray';
import _toString from 'lodash-es/toString';
import _replace from 'lodash-es/replace';
import _split from 'lodash-es/split';
import _forEach from 'lodash-es/forEach';

import { IGenericField } from '../generic-field';
import { TextFieldComponent } from "../text-field/text-field.component";

/**
 * Text-field
 * Generate a simple text field
 * @extends GenericField
 * @deprecated
 */
@Component({

    selector: 'time-field',
    templateUrl: './time-field.component.html',
    styleUrls: ['./time-field.component.scss'],
})
export class TimeFieldComponent extends TextFieldComponent implements IGenericField {

    /**
     * test pressed chars before Angular trigger them
     ***/
    public testChar(_event: any): any {
        return this.onlyTime(_event);
    }

    /* onlyTimeKeys
 *
 * force nuber charCode
 * https://stackoverflow.com/questions/37435529/angular2-proper-way-to-restrict-text-input-values-e-g-only-numbers
 * 48 to 53 : numbers
 * 13= Enter
 * add : and h and H
 */
    public onlyTime(_event: any): any {
        //add 58, 104, 72,
        // return isNumberKey;
        if (_event.charCode === 8 || _event.charCode === 0) { //backspace
            return false
        } else { //number
            return _event.charCode >= 48 && _event.charCode <= 57 || //numbers
                _event.charCode === 13 ||   //Enter
                (_event.charCode === 58 && this.canTypeSeparator()) ||   //:
                (_event.charCode === 104 && this.canTypeSeparator()) ||  //h
                (_event.charCode === 72 && this.canTypeSeparator())      //H
        }
    }

    /**
     * Test if a string is in value
     * @param _string
     */
    public valueContain(_string) {
        let val = this.group.get(this.controlName).value;
        return _includes(_toLower(val), _toLower(_string));
    }

    /**
     * test if separators h, : and H
     * @returns {boolean}
     */
    public canTypeSeparator(){
        return !this.valueContain('h') && !this.valueContain(':');
    }

    public onBlur($event): void{
        let val = this.group.get(this.controlName).value;
        val = _toLower(val);

        //if no separators
        if( !_includes(val, ':') && !_includes(val, 'h') && !_includes(val, 'H')){
            //HH and h case
            if(val.length === 2 ){
                val = val + ":00"
            }
            //H case
            else if(val.length === 1 ){
                val = "0" + val + ":00"
            }

            //HMM case
            else if(val.length === 3){
                let tempArray = _toArray(_toString(val));
                val = "0" + tempArray[0] + ":" + tempArray[1] + tempArray[2];
            }

            //HHMM case
            else if(val.length === 4){
                let tempArray = _toArray(_toString(val));
                val = tempArray[0]+tempArray[1]+":"+tempArray[2]+tempArray[3];
            }
        }else{
            //replace H and h by :
            val = _replace(val, 'h', ':');
            val = _replace(val, 'H', ':');
            //split by ":"
            let tempArray = _split(val, ':');



            _forEach(tempArray, (hm, index)=>{
                if(hm.length === 0){ // no hours or minutes
                    tempArray[index] = "00"
                }else if(hm.length === 1){ // hours or minute 1 car
                    tempArray[index] = "0"+hm
                }
            });

            val= tempArray[0] + ":" + tempArray[1];
        }


        this.group.get(this.controlName).patchValue(val);
        super.onBlur($event);

    }
}
